import { Grid2 as Grid, Link, Stack, Typography } from '@mui/material'

type Props = {
  name: string
  address1: string
  address2?: string
  city: string
  state: string
  storeId: string
}
export const StoreMainHeader: React.FC<Props> = props => {
  const { name, address1, address2, city, state, storeId } = props

  return (
    <Grid size={{ xs: 12 }}>
      <Stack direction="row" spacing={6}>
        <Typography variant="h3" gutterBottom>
          {name}
        </Typography>
        <Stack direction={'row'} spacing={2} alignItems="center">
          <Link href={`/stores/${storeId}/tasks`}>Tasks</Link>
          <Link href={`/restocks?storeIds[]=${storeId}`}>Restocks</Link>
        </Stack>
      </Stack>
      <Typography variant="body1" gutterBottom>
        {address1}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {address2}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {city}, {state}
      </Typography>
    </Grid>
  )
}
